import buildSimpleStringFilter from '../buildSimpleStringFilter'

const CapacityFilter = buildSimpleStringFilter({
  key: 'capacity',
  expandedOnInit: false,
})

export default CapacityFilter
